import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AdminPageLink = props => (
  <Link to={props.to} className="gradient-button p-50px mt-20px ml-20px fw-200px">
    {props.text}
  </Link>
);

AdminPageLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default AdminPageLink;
